import React from 'react';
import PropTypes from 'prop-types';
import {
  Card
} from 'day8-react/build/new-components';

const ImageGrid = props => {
  const { image } = props;
  return (
    <div className="d8-c-crew-finder-grid">
      <div className="d8-c-card d8-u-radius-md d8-u-primary-lighter-bg opacity-30%" />
      <div className="d8-c-card d8-u-radius-md d8-u-secondary-lighter-bg opacity-30%" />
      <div className="d8-u-zindex-header"><img className="d8-u-radius-md" src={image.url} alt={image.alt} /></div>
    </div>
  );
};


ImageGrid.propTypes = {
  image: PropTypes.string
};

export default ImageGrid;
